import { baseApi } from "./baseApi";

const configurationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query({
      query: () => ({
        url: "/configuration/feature-flags",
        method: "GET",
      }),
      providesTags: ["FeatureFlags"],
    }),

    saveFeatureFlags: builder.mutation({
      query: (body) => ({
        url: "/configuration/feature-flags",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FeatureFlags"],
    }),
  }),
});

export default configurationApi;
